// extracted by mini-css-extract-plugin
module.exports = {"coqgnfi":"coqgnfi","s1mxhqyx":"s1mxhqyx"};